<template>
    <pre-ai-step v-if="step==0" @generated="generated" @show-login-modal="$emit('show-login-modal')"/>
    <edit-step v-if="step==1" :doc="doc"/>
</template>
<script>
import PreAiStep from "@/Presentation/PreAiStep.vue";
import EditStep from "@/Presentation/EditStep.vue";

export default {
    components: {PreAiStep, EditStep},
    data() {
        return {
            step: 0,
            doc: null
        }
    },
    methods: {
        generated(doc) {
            this.doc = doc;
            this.step = 1;
        }
    },
    watch:{
        step(val){
            window.gtag('event','generatorStep', {val})
        }
    }

}
</script>
